import React from "react";

const PaginationBar = ({
  currentPage,
  totalPages,
  handlePageChange,
  paginationBarStyle,
}) => {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 10; // Maximum number of visible page numbers
    const maxPagesToShow = Math.min(maxVisiblePages, totalPages);

    // Helper function to render ellipses
    const renderEllipses = () => {
      return <span key="ellipsis">...</span>;
    };

    // Function to render page numbers between ellipses
    const renderPageRange = (start, end) => {
      const range = [];
      for (let i = start; i <= end; i++) {
        range.push(
          <span
            key={i}
            className={`pagination-number ${
              i === currentPage ? "disabled" : "active"
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </span>
        );
      }
      return range;
    };

    if (totalPages <= maxVisiblePages) {
      pageNumbers.push(...renderPageRange(1, totalPages));
    } else {
      if (currentPage <= 4) {
        pageNumbers.push(...renderPageRange(1, maxPagesToShow));
        pageNumbers.push(renderEllipses());
      } else if (currentPage >= totalPages - 3) {
        pageNumbers.push(renderEllipses());
        pageNumbers.push(
          ...renderPageRange(totalPages - maxPagesToShow + 1, totalPages)
        );
      } else {
        const start = currentPage - Math.floor(maxVisiblePages / 2);
        const end = currentPage + Math.floor(maxVisiblePages / 2);
        pageNumbers.push(renderEllipses());
        pageNumbers.push(...renderPageRange(start, end));
        pageNumbers.push(renderEllipses());
      }
    }

    return pageNumbers;
  };

  return (
    <div className="absolute w-[calc(100%-226px)] flex flex-row items-center justify-center gap-[30px] mb-5 mt-10 p-2 bg-white"
    style={paginationBarStyle}>
      {currentPage > 1 && (
        <>
          <span
            className="flex mx-5"

            onClick={() => handlePageChange(currentPage - 1)}
          >
            <svg
              className="mr-2"
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M6.33251 13.2781L9.62742 16.5469C9.7619 16.6804 9.82646 16.836 9.82108 17.0139C9.8157 17.1918 9.74554 17.3475 9.61061 17.4809C9.47612 17.6032 9.31922 17.6672 9.13991 17.673C8.96059 17.6788 8.80369 17.6148 8.6692 17.4809L4.23116 13.078C4.16392 13.0112 4.11618 12.939 4.08793 12.8611C4.05969 12.7833 4.04602 12.6999 4.04692 12.611C4.04692 12.522 4.06104 12.4386 4.08928 12.3608C4.11752 12.283 4.16482 12.2107 4.23116 12.144L8.6692 7.74107C8.79248 7.61877 8.94669 7.55762 9.13184 7.55762C9.31698 7.55762 9.47657 7.61877 9.61061 7.74107C9.74509 7.87449 9.81234 8.03304 9.81234 8.21672C9.81234 8.4004 9.74509 8.55873 9.61061 8.6917L6.33251 11.9439H20.5712C20.7617 11.9439 20.9216 12.0079 21.0507 12.136C21.1798 12.2641 21.2441 12.4224 21.2437 12.611C21.2437 12.8 21.1791 12.9585 21.05 13.0866C20.9209 13.2147 20.7613 13.2785 20.5712 13.2781H6.33251Z"
                fill="#1D2739"
              />
            </svg>
            Previous
          </span>
        </>
      )}

      {currentPage === 1 && (
        <span
          className="flex mx-5"

          disabled
          style={{ color: "#7B7B7B" }}
        >
          <svg
            className="mr-2"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M6.33251 13.2781L9.62742 16.5469C9.7619 16.6804 9.82646 16.836 9.82108 17.0139C9.8157 17.1918 9.74554 17.3475 9.61061 17.4809C9.47612 17.6032 9.31922 17.6672 9.13991 17.673C8.96059 17.6788 8.80369 17.6148 8.6692 17.4809L4.23116 13.078C4.16392 13.0112 4.11618 12.939 4.08793 12.8611C4.05969 12.7833 4.04602 12.6999 4.04692 12.611C4.04692 12.522 4.06104 12.4386 4.08928 12.3608C4.11752 12.283 4.16482 12.2107 4.23116 12.144L8.6692 7.74107C8.79248 7.61877 8.94669 7.55762 9.13184 7.55762C9.31698 7.55762 9.47657 7.61877 9.61061 7.74107C9.74509 7.87449 9.81234 8.03304 9.81234 8.21672C9.81234 8.4004 9.74509 8.55873 9.61061 8.6917L6.33251 11.9439H20.5712C20.7617 11.9439 20.9216 12.0079 21.0507 12.136C21.1798 12.2641 21.2441 12.4224 21.2437 12.611C21.2437 12.8 21.1791 12.9585 21.05 13.0866C20.9209 13.2147 20.7613 13.2785 20.5712 13.2781H6.33251Z"
              fill="#1D2739"
            />
          </svg>
          Previous
        </span>
      )}

      {renderPageNumbers()}

      {currentPage < totalPages && (
        <>
          <span
            className="flex mx-5"

            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
            <svg
              className="ml-2"
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M18.3486 13.2781L15.0537 16.5469C14.9192 16.6804 14.8547 16.836 14.8601 17.0139C14.8655 17.1918 14.9356 17.3475 15.0705 17.4809C15.205 17.6032 15.3619 17.6672 15.5412 17.673C15.7206 17.6788 15.8775 17.6148 16.0119 17.4809L20.45 13.078C20.5172 13.0112 20.565 12.939 20.5932 12.8611C20.6215 12.7833 20.6351 12.6999 20.6342 12.611C20.6342 12.522 20.6201 12.4386 20.5919 12.3608C20.5636 12.283 20.5163 12.2107 20.45 12.144L16.0119 7.74107C15.8887 7.61877 15.7345 7.55762 15.5493 7.55762C15.3642 7.55762 15.2046 7.61877 15.0705 7.74107C14.9361 7.87449 14.8688 8.03304 14.8688 8.21672C14.8688 8.4004 14.9361 8.55873 15.0705 8.6917L18.3486 11.9439H4.10993C3.9194 11.9439 3.75959 12.0079 3.63048 12.136C3.50138 12.2641 3.43705 12.4224 3.43749 12.611C3.43749 12.8 3.50205 12.9585 3.63116 13.0866C3.76026 13.2147 3.91985 13.2785 4.10993 13.2781H18.3486Z"
                fill="#1D2739"
              />
            </svg>
          </span>
        </>
      )}

      {currentPage === totalPages && (
        <span
          className="flex mx-5"

          disabled
          style={{ color: "#7B7B7B" }}
        >
          Next
          <svg
            className="ml-2"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
          >
            <path
              d="M18.3486 13.2781L15.0537 16.5469C14.9192 16.6804 14.8547 16.836 14.8601 17.0139C14.8655 17.1918 14.9356 17.3475 15.0705 17.4809C15.205 17.6032 15.3619 17.6672 15.5412 17.673C15.7206 17.6788 15.8775 17.6148 16.0119 17.4809L20.45 13.078C20.5172 13.0112 20.565 12.939 20.5932 12.8611C20.6215 12.7833 20.6351 12.6999 20.6342 12.611C20.6342 12.522 20.6201 12.4386 20.5919 12.3608C20.5636 12.283 20.5163 12.2107 20.45 12.144L16.0119 7.74107C15.8887 7.61877 15.7345 7.55762 15.5493 7.55762C15.3642 7.55762 15.2046 7.61877 15.0705 7.74107C14.9361 7.87449 14.8688 8.03304 14.8688 8.21672C14.8688 8.4004 14.9361 8.55873 15.0705 8.6917L18.3486 11.9439H4.10993C3.9194 11.9439 3.75959 12.0079 3.63048 12.136C3.50138 12.2641 3.43705 12.4224 3.43749 12.611C3.43749 12.8 3.50205 12.9585 3.63116 13.0866C3.76026 13.2147 3.91985 13.2785 4.10993 13.2781H18.3486Z"
              fill="#1D2739"
            />
          </svg>
        </span>
      )}
    </div>
  );
};

export default PaginationBar;
